import { render, staticRenderFns } from "./ModalSelectPage.vue?vue&type=template&id=a4fab3a2&scoped=true&"
import script from "./ModalSelectPage.vue?vue&type=script&lang=js&"
export * from "./ModalSelectPage.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectPage.vue?vue&type=style&index=0&id=a4fab3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fab3a2",
  null
  
)

export default component.exports